<template>
  <div
    class="views-page is-flex is-flex-direction-column px-5 pt-3 pb-5"
    style="min-height: 50vh; overflow-x: auto"
  >
    <div
      class="info-line"
      :class="GetMessagesData.main_color"
    />
    <b-loading
      :is-full-page="false"
      v-model="isLoading"
      :can-cancel="false"
    />
    <div class="is-flex is-align-items-center is-justify-content-space-between mb-5">
      <div class="report-type__buttons">
        <b-button
          class="button is-info"
          :class="[reportType !== 'short' && 'is-outlined']"
          @click="reportType = 'short'"
        >Краткий отчет</b-button>
        <b-button
          class="button is-info"
          :class="[reportType !== 'full' && 'is-outlined']"
          @click="reportType = 'full'"
        >Подробный отчет</b-button>
      </div>
      <button
        class="button is-success"
        @click="exportPDF"
      >Скачать PDF</button>
    </div>
    <div v-html="getMarked()" class="content"></div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex"
import { Remarkable } from "remarkable"

export default {
  props: ["device_id", "report_id"],
  data() {
    return {
      fullReportContent: "",
      shortReportContent: "",
      isLoading: true,
      isExporting: false,
      reportType: 'short'
    }
  },
  computed: mapGetters(["GetMessagesData"]),
  created() {
    // this.ChangeNavName("Архивные сообщения")
    this.FetchMessages(this.device_id)
    this.fetchMessages()
  },
  methods: {
    ...mapActions(["FetchArchiveMsg", "FetchMessages"]),
    ...mapMutations(["ChangeNavName"]),
    getMarked() {
      let md = new Remarkable("full", {
        html: true,
        breaks: true,
        typographer: true,
      })
      return md.render(this.reportType === 'short' ? this.shortReportContent : this.fullReportContent)
    },
    async fetchMessages(page) {
      this.currentPage = page || 1
      this.isLoading = true
      try {
        const { data } = await this.$axios.get(`ai-request-sets/${this.report_id}/last`)
        this.fullReportContent = data?.full_report?.response ?? ""
        this.shortReportContent = data?.short_report?.response ?? ""
      } catch (e) {
        this.isLoading = false
        throw new Error(e)
      }
      this.isLoading = false
    },
    getFilenameFromContentDisposition(contentDisposition, defaultName = "file") {
      if ( !contentDisposition) return defaultName
      const matches = contentDisposition?.match(/filename="([^"]+)"/)
      if (matches && matches.length > 1) {
        return matches[1]
      }
      return defaultName
    },

    async exportPDF() {
      this.isExporting = true
      try {
        const {
          data,
          headers,
        } = await this.$axios.get(`ai-request-sets/${this.report_id}/${this.reportType === 'short' ? 'short-pdf' : 'pdf'}`, {
          responseType: "blob",
        })
        const fileName = this.getFilenameFromContentDisposition(headers["content-disposition"])
        const file = new Blob([data], { type: headers["content-type"] })
        const url = URL.createObjectURL(file)
        const link = document.createElement("a")
        link.href = url
        link.setAttribute("download", fileName)
        link.target = "_blank"
        document.body.appendChild(link)
        link.click()
        setTimeout(() => {
          link.remove()
          URL.revokeObjectURL(url)
        })
      } catch (e) {
        console.error(e)
        throw e
      } finally {
        this.isExporting = false
      }
    },

  },
}
</script>

<style>
.report-type__buttons button:first-child {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.report-type__buttons button:last-child {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}
</style>

